import {
  REST_OF_REGION_LABS,
  type PowerLabId,
  type PowerRegionData,
  type PowerRegionId,
} from "./powerBubbleChartData"

// Identifies which row (a country or a single lab) is currently being hovered
// inside the chart so the tooltip can highlight the matching line. "chart" is
// the whole-chart hover: the pointer is inside the treemap's column but not on
// a specific cell yet — the HUD's in-canvas takeover shows immediately with
// nothing highlighted (see ClaimPowerHoverOnEnter in hoverSwapStickyZone.tsx).
export type HoveredPowerItem =
  | { kind: "region"; id: PowerRegionId }
  | { kind: "lab"; id: PowerLabId }
  | { kind: "chart" }

// Resolves any hovered item (lab or country) back to the country it belongs to,
// so chart cells and tooltip rows can co-highlight every sibling in that country.
export const getHoveredRegionId = (
  hoveredItem: HoveredPowerItem | null,
  regions: PowerRegionData[]
): PowerRegionId | null => {
  if (hoveredItem === null || hoveredItem.kind === "chart") return null
  if (hoveredItem.kind === "region") return hoveredItem.id
  const ownerRegion = regions.find(region =>
    region.labs.some(lab => lab.id === hoveredItem.id)
  )
  if (ownerRegion) return ownerRegion.id
  // The treemap's "Rest of X" cells can be SYNTHESIZED by the prune
  // (pruneSmallToRest rolls sliver companies into a tail block it creates
  // when the data carries no aggregate lab), so their id may not exist in
  // regions[].labs — resolve those by the static tail→region mapping, or
  // hovering them would light no country group at all.
  const restRegionId = (Object.keys(REST_OF_REGION_LABS) as PowerRegionId[])
    .find(regionId => REST_OF_REGION_LABS[regionId].id === hoveredItem.id)
  return restRegionId ?? null
}
